import { render } from "./BaseNavSecondary.vue?vue&type=template&id=fd08da58"
import script from "./BaseNavSecondary.vue?vue&type=script&lang=js"
export * from "./BaseNavSecondary.vue?vue&type=script&lang=js"

import "./BaseNavSecondary.vue?vue&type=style&index=0&id=fd08da58&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__